import ClientPageHistory from './ClientPageHistory';

export default ClientPageHistory;
